import {
  JbOverlay
} from "./chunk.75HJXTVU.js";
import {
  disableBodyScroll,
  enableBodyScroll
} from "./chunk.WDF6H473.js";
import {
  jb_contact_overlay_css_default
} from "./chunk.GSJS5RRS.js";
import {
  Spaceable
} from "./chunk.UK6KU6OP.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  Animatable
} from "./chunk.27HF5Y4Z.js";
import {
  recenterNavItems
} from "./chunk.NKAUZW5M.js";
import {
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  e,
  n
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-contact-overlay/jb-contact-overlay.ts
var JbContactOverlay = class extends Initiable(Spaceable(Animatable(r))) {
  async firstUpdated(changedProperties) {
    super.firstUpdated(changedProperties);
    await this.updateComplete;
    this.dispatchEvent(
      new CustomEvent("jb-tracking", {
        detail: {
          event: "ce_form",
          event_version: "v2",
          component_name: "contact-overlay",
          form_component: this._form,
          form_step_name: "form open",
          form_step_nr: "1",
          form_subject: this.formToDisplay.trackingSubject || "",
          form_type: "contact"
        },
        bubbles: true,
        composed: true
      })
    );
    this.contentChildren = [];
    const formHeader = this._form.shadowRoot.querySelector(".formheader");
    if (formHeader) {
      this.contentChildren.push(...Array.from(formHeader.children));
    }
    if (this._form.shadowRoot.querySelector("h3")) {
      this.contentChildren.push(this._form.shadowRoot.querySelector("h3"));
    }
    this._form.addEventListener("jb-form:ready", () => {
      this.contentChildren.push(...Array.from(this._form.children));
      this.contentChildren.forEach((element) => {
        element.style.setProperty("opacity", "0");
      });
    });
    document.addEventListener("jb-overlay:close", () => {
      this._prepareToClose();
    });
    if (document.querySelector("jb-focus-fly")?._isVisible()) {
      setTimeout(() => {
        this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
      }, 500);
    } else {
      setTimeout(() => {
        this.shadowRoot.activeElement?.blur();
      }, 100);
    }
  }
  static async open(event) {
    const customEvent = event;
    if (!customEvent.detail.contactOverlayForm) return;
    if (customEvent.detail.clickEvent) {
      customEvent.detail.clickEvent.preventDefault();
      customEvent.detail.clickEvent.stopPropagation();
    }
    customEvent.stopPropagation();
    const contactOverlay = new JbContactOverlay().init({
      props: {
        formIdentifier: customEvent.detail.contactFormUid,
        formToDisplay: customEvent.detail.contactOverlayForm,
        withSpacing: true
      }
    });
    new JbOverlay().init({
      props: {
        color: "white",
        hasLogo: true,
        logoLink: customEvent.detail.logoLink,
        ariaLabels: customEvent.detail.overlayAriaLabels,
        svgLogo: customEvent.detail.svgLogo,
        newAnimation: true,
        returnFocusTo: customEvent.detail.linkTag
      },
      childNodes: [contactOverlay]
    }).stack();
    disableBodyScroll(contactOverlay, { allowTouchMove: () => true });
    recenterNavItems();
    contactOverlay.addEventListener("jb-form:ready", async () => {
      await contactOverlay.animateWrapper();
      await contactOverlay.animateWrapperControls();
      contactOverlay.animateContent();
    });
  }
  _captureTracking(evt) {
    evt.stopPropagation();
  }
  _getContentSpacingProperties() {
    return { grid: "legacy", colsMdUp: 8, colsLgUp: 6 };
  }
  async _prepareToClose() {
    await this.hide();
    const { parentElement } = this;
    const grandparentElement = parentElement.parentElement;
    if (parentElement.tagName === "JB-OVERLAY") {
      parentElement.unstack();
    }
    if (grandparentElement.tagName === "JB-OVERLAY") {
      grandparentElement.unstack();
    }
    enableBodyScroll(this);
    recenterNavItems();
  }
  render() {
    return ke`
      <jb-form
        .action=${this.formToDisplay.action}
        .additionalData=${this.formToDisplay.additionalData}
        .bordered=${this.formToDisplay.bordered}
        .contentElements=${this.formToDisplay.contentElements}
        .formHeader=${this.formToDisplay.formHeader}
        .formIdentifier=${this.formToDisplay.formIdentifier}
        .generalConcern=${this.formToDisplay.generalConcern}
        .multiformSubline=${this.formToDisplay.multiformSubline}
        .recipient="${this.formToDisplay.recipient}"
        .recipientPhone=${this.formToDisplay.recipientPhone}
        .recipientPosition=${this.formToDisplay.recipientPosition}
        .trackingSubject=${this.formToDisplay.trackingSubject}
        .validationFieldname=${this.formToDisplay.validationFieldname}
        displayGrid
        @jb-tracking=${this._captureTracking}
      ></jb-form>
    `;
  }
};
JbContactOverlay.styles = [reset_css_default, jb_contact_overlay_css_default];
__decorateClass([
  n()
], JbContactOverlay.prototype, "formIdentifier", 2);
__decorateClass([
  n({ type: Object })
], JbContactOverlay.prototype, "formToDisplay", 2);
__decorateClass([
  n()
], JbContactOverlay.prototype, "svgLogo", 2);
__decorateClass([
  e("jb-form")
], JbContactOverlay.prototype, "_form", 2);
JbContactOverlay = __decorateClass([
  customElement("jb-contact-overlay")
], JbContactOverlay);
document.body.addEventListener("jb-link:clicked", JbContactOverlay.open);

export {
  JbContactOverlay
};
